import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { showNotification } from 'react-admin'
import Bids from './lotShowBidTable'

export default connect(null, {
  push,
  showNotification
})(Bids)
